
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionItemsGrid extends Serenity.EntityGrid<QualityInspectionItemsRow, any> {
        protected getColumnsKey() { return 'Production.QualityInspectionItems'; }
        protected getDialogType() { return QualityInspectionItemsDialog; }
        protected getIdProperty() { return QualityInspectionItemsRow.idProperty; }
        protected getInsertPermission() { return QualityInspectionItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return QualityInspectionItemsRow.localTextPrefix; }
        protected getService() { return QualityInspectionItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}